import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { switchMap } from 'rxjs/operators';
import { ApiPartnerService } from '../../api/api-partner.service';
import { FormGroup, FormControl, FormBuilder, NgForm } from '@angular/forms';
import { LoadJsService } from '../../load-js/load-js.service';
import { ApiService } from '../../api/api.service';



@Component({
  selector: 'app-marketplace-form',
  templateUrl: './marketplace-form.component.html',
  styleUrls: ['./listorder.component.css']
})
export class MarketplaceformComponent implements OnInit {

  constructor(
    public api: ApiService,
    public partnerService: ApiPartnerService,
    public router: Router
  ) { }
  
  timestart = {hour: 15, minute: 58};
  timeend = {hour: 15, minute: 58};
  date =new Date();
  waktupickups = {year: this.date.getFullYear(), month: (this.date.getMonth()+1), day : this.date.getDate()};
  
  
  customeremail:any=[];

  multiproduct = true;
  detailproducts : any = [];

  province : [];
 
  city : [];
  district : [];
  subdistrict : [];
  listproducts = [];
  listkurirs = [];
  listlokasigudang = [];
  listshippingtype = [];
  lokasigudang : number;
  shippingtype : number;
  waktupickup : string;
  noresi : string;


  product : number;
  jumlah : number = 1;
  harga : number;
  totalharga : number = 0;
  ongkir : number = 0;
  berat : number = 1;
  totalongkir : number = 0;
  totalpayment : number = 0;
  totaltagihan : number = 0;
  ordersuccess = [];

  shopstore = [];

  kota : string;
  prov : string;
  dest : string;
  Courier : string;
  Jenis : string = 'REG';
  Orig : string = 'JKT';


  //contactbuyer : {};
  ongkirs : {};
  orders : {};
  shippingData:any = {};
  
  openBeli = true;
  formopen = true;
  ordersukses = false;
  namacust : string;

  myProv : number;
  myCity : number;
  myDistrict : number;
  mySubdistrict : number;
  contactbuyer = {name:'',email:''};

  subdistrictData:any= 100
  postalcode:any= {}

  load1 = false
  load2 = false
  load3 = false
  load4 = false
  load5 = false
  load6 = false
  load7 = false
  iszip = false

  ngOnInit() {
    this.loadprovince();
    this.loadshop();
    this.loadproduct();
    this.loadkurir();
    this.loadlokasigudang();
    this.loadshippingtype();
    console.log(this.date);
  }

  resetform(el: HTMLElement){
    setTimeout(() => {
      el.scrollIntoView({behavior: "smooth"})
      
      setTimeout(() => {
        window.location.reload()
      }, 800);
    }, 100);

  }
  
  onChangeJumlah(event: any)
  {
    //alert(this.product);
    let obj = this.listproducts.find(obj => obj.id == this.product);
    if ( obj != undefined )
    {  
      this.harga = obj.price * this.jumlah;
      this.totalharga = obj.price * this.jumlah;
      this.totalongkir = this.jumlah * this.ongkir;
      console.log({ongkir:this.ongkir,jumlah:this.jumlah});
      this.berat = this.jumlah * 1;
      this.forTotalPayment();
      this.orders = [{id:obj.id,name:obj.productname,price:obj.price,qty:this.jumlah,total:this.totalharga}];
      this.ongkirs = {berat:this.berat,price:this.ongkir,jumlah:this.jumlah,total:this.totalongkir};
      this.totaltagihan = this.totalpayment;

    }else{
      this.harga = 0;
      this.totalharga = 0;  
      this.totalongkir = this.jumlah * this.ongkir;
      this.orders = [];
      this.ongkirs = {};
      this.totaltagihan = 0;

    }



  }

  onChangeProd()
  {
    //alert(this.product);
    let obj = this.listproducts.find(obj => obj.id == this.product);
    this.harga = obj.price * this.jumlah;
    this.totalharga = obj.price * this.jumlah;
    this.totalongkir = this.jumlah * this.ongkir;
    this.berat = this.jumlah * 1;
    this.forTotalPayment();
    this.orders = [{id:obj.id,name:obj.productname,price:obj.price,qty:this.jumlah,total:this.totalharga}];
    this.ongkirs = {berat:this.berat,price:this.ongkir,jumlah:this.jumlah,total:this.totalongkir};
    this.totaltagihan = this.totalpayment;
  }

  
  shipping() {
    let kurir = this.listkurirs.find(obj => obj.id == this.Courier);
    let jenispengiriman = this.listshippingtype.find(obj => obj.id == this.shippingtype);
    let lokgudang = this.listlokasigudang.find(obj => obj.id == this.lokasigudang);

    this.shippingData['shippingname'] = kurir.name;
    this.shippingData['destination'] = {
      kota:this.kota,
      prov:this.prov,
      destination:this.dest,
      zipcode:this.contactbuyer['zipcode'],
    }
    this.shippingData['price'] = this
    .ongkir;
    this.shippingData['source'] = window.location.href;
    this.shippingData['kuririd'] = this.Courier;
    this.shippingData['noresi'] = this.noresi;
    this.shippingData['jenispengirimanid'] = this.shippingtype;
    this.shippingData['jenispengiriman'] = jenispengiriman.name;
    this.shippingData['marketplacelokasigudangid'] = this.lokasigudang;
    this.shippingData['marketplacelokasigudang'] = lokgudang.name;
    this.shippingData['waktupickup'] = this.waktupickup;
  }

  forTotalPayment()
  {
    this.totalpayment = this.totalharga + this.totalongkir;
  }

  savet(){
    console.log(this.waktupickups);
    console.log(this.timestart,this.timeend);
    this.waktupickup = this.waktupickups['year']+'-'+this.waktupickups['month']+'-'+this.waktupickups['day']
                      + ' ' + this.timestart['hour']+':'+this.timestart['minute']+'-'+this.timeend['hour']+':'+this.timeend['minute'];
  
    console.log(this.waktupickup);
  }


  save()
  {
    if ( !confirm('Yakin untuk submit order ? ')) {
        return;
    }


    

    this.contactbuyer['subdistrictid'] = this.subdistrictData.id
    this.contactbuyer['subdistrictname'] = this.subdistrictData.name
    this.openBeli = false;
    this.contactbuyer['shopcode'] = 'MARKETPLACE'; // marketplace
    this.ongkirs = {berat:this.berat,price:this.ongkir,jumlah:this.jumlah,total:this.totalongkir};
    this.forTotalPayment();
    this.shipping()
    this.totaltagihan = this.totalpayment;

    
    this.contactbuyer['alamat'] = this.contactbuyer['alamat']+', RT '+this.contactbuyer['rt']+', RW '+this.contactbuyer['rw']
    this.contactbuyer['notes'] = 'Order by Playboxstore'
    
    let data = {
      customer:this.contactbuyer,
      order:this.orders,
      ongkir:this.ongkirs,
      totaltagihan:this.totaltagihan,
      shipping: this.shippingData
    };

    console.log(data)
    //return;
    this.customeremail = this.contactbuyer['email']

    this.api.PostCheckout(data).subscribe((output: any) => {
      console.log(output);

      this.formopen = false;
      this.ordersukses = true;
      this.openBeli = true;
      // this.ordersuccess['nama'] = output['data']['nama'];
      // this.ordersuccess['customer_email'] = output['data']['customer_email'];
      // this.ordersuccess['accountid'] = output['data']['accountid'];
      // this.ordersuccess['total'] = output['data']['total'];

      this.router.navigateByUrl("/adminecommerce/view/"+output['data']['trx_id']);
    //return;

      // setTimeout(() => {
      //   window.open('https://b2b-api.mncplay.id/billmain.php?CID='+this.ordersuccess['accountid'])
      // }, 1000);
    });
/*
    setTimeout(() => 
  {
      this.formopen = false;
      this.ordersukses = true;
      this.openBeli = true;
  },
  500);
*/

  }

  loadshop()
  {
    this.load1 = true
    return this.api.GetStoreShop('').subscribe((output: {}) => {
      console.log(output);
      this.shopstore = output['data'];
      this.load1 = false

      });

  }

  loadprovince()
  {
    this.load1 = true
    return this.api.GetProvince().subscribe((output: {}) => {
      console.log(output);
      this.province = output['data'];
      this.load1 = false

      });

  }


  loadcity(id)
  {
    this.load2 = true
    return this.api.GetCity(id).subscribe((output: {}) => {
      console.log(output);
      this.city = output['data'];
      this.load2 = false

      });

  }

  loaddistrict(id)
  {
    this.load3 = true
    return this.api.GetDistrict(id).subscribe((output: {}) => {
      console.log(output);
      this.district = output['data'];
      this.load3 = false

      });

  }

  loadsubdistrict(id)
  {
    this.load4 = true
    return this.api.GetSubdistrict(id).subscribe((output: {}) => {
      console.log(output);
      this.subdistrict = output['data'];
      this.load4 = false

      });


  }

  loadproduct()
  {
    this.load6 = true
    let querystr = '?channel=MARKETPLACE';
    return this.api.GetProduct(querystr).subscribe((output: {}) => {
      console.log(output);
      this.listproducts = output['data'];
      this.load6 = false


      });
  }

  loadkurir()
  {
    this.load6 = true
    let querystr = '';
    return this.api.GetStoreKurir(querystr).subscribe((output: {}) => {
      console.log(output);
      this.listkurirs = output['data'];
      this.load6 = false


      });
  }

  loadlokasigudang()
  {
    this.load6 = true
    let querystr = '';
    return this.api.GetStoreLokasigudang(querystr).subscribe((output: {}) => {
      console.log(output);
      this.listlokasigudang = output['data'];
      this.load6 = false


      });
  }

  loadshippingtype()
  {
    this.load6 = true
    let querystr = '';
    return this.api.GetStoreShippingtype(querystr).subscribe((output: {}) => {
      console.log(output);
      this.listshippingtype = output['data'];
      this.load6 = false


      });
  }

  loadPostalcode(param)
  {
    this.load5 = true
    this.iszip = false
    let data = {
      'district_id': param.district_id,
      'subdistrict_name': param.name
    }
    return this.api.GetPostalcode(data).subscribe((output: any) => {
      console.log(output);
      if(output.status){

        this.postalcode = output.data;
        this.iszip = true
        this.load5 = false
        
        this.contactbuyer['zipcode'] = this.postalcode.postal_code
      }else{
        // this.iszip = false
        this.load5 = false
      }


    });
  }

  changeProv()
  {
    this.contactbuyer['zipcode'] = ""
    let ids = this.contactbuyer['provinceid'];
    this.loadcity(ids);
    this.district = [];
    this.subdistrict = [];
    this.myCity = null;
    this.myDistrict = null;
    this.mySubdistrict  = null;

    let result = this.province.find( ({ id }) => id == ids );
    this.prov = result['name'];


  }

  changeCity()
  {
    this.contactbuyer['zipcode'] = ""
    let ids = this.contactbuyer['cityid'];
    this.loaddistrict(ids);
    this.subdistrict = [];
     this.myDistrict = null;
    this.mySubdistrict  = null;
    let result = this.city.find( ({ id }) => id == ids );
    
    this.kota = result['name'];

  }

  changeDistrict()
  {
    this.contactbuyer['zipcode'] = ""
    let ids = this.contactbuyer['districtid'];
    this.loadsubdistrict(ids);

    this.mySubdistrict  = null;
    const result = this.district.find( ({ id }) => id == ids );
    this.dest = result['name'];
    console.log(this.contactbuyer);
    console.log(this.district);
    console.log(ids);
    console.log(result);

    this.GoOngkir();
    
  }

  changeSubdistrict()
  {
    // let id = this.contactbuyer['subdistrict']['id'];
    // let name = this.contactbuyer['subdistrict']['name'];
    //this.loadsubdistrict(id);
    // console.log(this.subdistrictData, this.subdistrictData.id, this.subdistrictData.name)
    this.contactbuyer['zipcode'] = ""
    this.loadPostalcode(this.subdistrictData)

  }

  changeCourier()
  {
     this.GoOngkir();
  }

  ongkirSicepat(querystr){
    this.load7 = true
    return this.api.GetOngkirsicepat(querystr).subscribe((output: {}) => {
      console.log(output);
      this.ongkir = output['data']['tarif'];
      this.load7 = false
      this.totalongkir = this.jumlah * this.ongkir;
      this.ongkirs = {berat:this.berat,price:this.ongkir,jumlah:this.jumlah,total:this.totalongkir};
      this.forTotalPayment();
      this.totaltagihan = this.totalpayment;
    });
  }

  ongkirTiki(querystr){
    this.load7 = true
    return this.api.GetOngkirtiki(querystr).subscribe((output: {}) => {
      console.log(output);
      this.ongkir = output['data']['tarif'];
      this.load7 = false
      this.totalongkir = this.jumlah * this.ongkir;
      this.ongkirs = {berat:this.berat,price:this.ongkir,jumlah:this.jumlah,total:this.totalongkir};
      this.forTotalPayment();
      this.totaltagihan = this.totalpayment;
    });
  }

  
  ongkirMNC(){
    this.ongkir = 20000; // flat
    this.load7 = false
    this.totalongkir = this.jumlah * this.ongkir;
    this.ongkirs = {berat:this.berat,price:this.ongkir,jumlah:this.jumlah,total:this.totalongkir};
    this.forTotalPayment();
    this.totaltagihan = this.totalpayment;
  }

  GoOngkir()
  {
    if ( this.Courier == 'SICEPAT' ){
      this.ongkirSicepat({dest:this.dest,kota:this.kota,berat:this.berat});
    } else if ( this.Courier == 'TIKI' ){

      this.ongkirTiki({orig:this.Orig,jenis:this.Jenis, prov:this.prov,kec:this.dest,kota:this.kota,berat:this.berat});

    } else if ( this.Courier == 'MNC' ){
      this.ongkirMNC();
    }

    console.log(this.totalpayment);
  }
  
  redirecturl(){
    window.open('https://b2b-api.mncplay.id/billmain.php?CID='+this.ordersuccess['accountid'])
  }

  addproduct()
  {
    //this.persons =  this.listproducts.find(x => x.id == this.product);

    let thisproduct = this.listproducts.find(x => x.id == this.product);
    //thisproduct = {'productid':this.product};
    
    this.detailproducts.push(thisproduct);
    console.log(this.detailproducts);
    alert('add');
  }

}

